import { filterStartsWith } from '@/utils/shared'

const templatePrice = (data) => [data.price, data.currency].filter(v => v).join(' ')

export default ({ employeeID }) => ({
  id: 'rfq-pending',
  mode: {
    isModalNew: true
  },
  store: {
    get: {
      url: 'Panels/GetAllPanelRFQListing',
      orderBy: {
        field: 'rfQ1ID',
        order: 'desc'
      }
    },
    mainField: 'rfqidFromRFQ1',
    rowFieldKey: 'rfQ1ID'
  },
  header: {
    controls: {
      isVisible: true,
      export: {
        json: {
          current: {
            isVisible: false
          },
          all: {
            isVisible: false
          }
        }
      },
      addNew: {
        isVisible: false
      }
    }
  },
  columns: [
    {
      // eslint-disable-next-line no-template-curly-in-string
      title: '${root.L10n("part-number")}',
      field: 'partNumber',
      styles: {
        maxWidth: '20rem'
      },
      template: 'filter',
      filterID: 'partID',
      filterValue: (data) => data.partID
    },
    {
      // eslint-disable-next-line no-template-curly-in-string
      title: '${root.L10n("customer")}',
      field: 'customerCompanyName',
      styles: {
        maxWidth: '15rem'
      },
      template: 'filter',
      filterID: 'customerCompanyID',
      filterValue: (data) => data.customerCompanyID
    },
    {
      // eslint-disable-next-line no-template-curly-in-string
      title: '${root.L10n("contact")}',
      field: 'customerContactName',
      styles: {
        maxWidth: '10rem'
      }
    },
    {
      // eslint-disable-next-line no-template-curly-in-string
      title: '${root.L10n("po")}',
      field: 'po'
    },
    {
      // eslint-disable-next-line no-template-curly-in-string
      title: '${root.L10n("employee")}',
      field: 'employeeName',
      template: 'filter',
      filterID: 'employeeID',
      filterValue: (data) => data.employeeID
    },
    {
      // eslint-disable-next-line no-template-curly-in-string
      title: '${root.L10n("condition")}',
      field: 'conditionTitle',
      styles: {
        maxWidth: '10rem'
      }
    },
    {
      // eslint-disable-next-line no-template-curly-in-string
      title: '${root.L10n("price")}',
      field: 'price',
      // eslint-disable-next-line no-template-curly-in-string
      template: templatePrice,
      export: {
        excel: {
          template: templatePrice
        }
      }
    },
    {
      // eslint-disable-next-line no-template-curly-in-string
      title: "${root.L10n('company-type')}",
      field: 'companyTypeTitle'
    },
    {
      // eslint-disable-next-line no-template-curly-in-string
      title: '${root.L10n("part-sn")}',
      field: 'partSN'
    },
    {
      // eslint-disable-next-line no-template-curly-in-string
      title: "${root.L10n('score')}",
      field: 'scoreTitle'
    },
    {
      // eslint-disable-next-line no-template-curly-in-string
      title: "${root.L10n('rfq-id')}",
      field: 'rfqidFromRFQ1'
    }
  ],
  rowControls: {
    right: {
      classes: 'controls-inline',
      controls: [
        {
          type: 'edit'
        }
      ]
    }
  },
  toolbar: {
    filters: [
      {
        type: 'string',
        field: 'title',
        options: {
          // eslint-disable-next-line no-template-curly-in-string
          valueTemplate: '( rfqidFromRFQ1.contains("${data.value}") || customerCompanyName.StartsWith("${data.value}") || employeeName.contains("${data.value}") )',
          // eslint-disable-next-line no-template-curly-in-string
          placeholder: '${root.L10n("search")}',
          styles: {
            minWidth: '16rem'
          }
        }
      },
      {
        id: 'partID',
        type: 'selectautocomplete',
        field: 'partID',
        // eslint-disable-next-line no-template-curly-in-string
        label: "${root.L10n('part')}",
        options: {
          dataSource: {
            url: 'Parts/GetAllDynamic',
            selected: 'id,partNumber,partDescription,remark'
          },
          searchAllColumns: true,
          columns: [
            {
              // eslint-disable-next-line no-template-curly-in-string
              title: "${root.L10n('part-number')}",
              value: 'partNumber',
              originField: 'partNumber',
              type: 'custom',
              customFilter: filterStartsWith
            },
            {
              // eslint-disable-next-line no-template-curly-in-string
              title: "${root.L10n('part-description')}",
              value: 'partDescription',
              originField: 'partDescription',
              type: 'custom',
              customFilter: filterStartsWith
            }
          ],
          option: {
            label: 'partNumber'
          },
          // eslint-disable-next-line no-template-curly-in-string
          placeholder: "${root.L10n('all')}"
        }
      },
      {
        id: 'customerCompanyID',
        type: 'selectautocomplete',
        field: 'customerCompanyID',
        // eslint-disable-next-line no-template-curly-in-string
        label: '${root.L10n("customer")}',
        options: {
          // eslint-disable-next-line no-template-curly-in-string
          templateFilter: 'name.StartsWith("${data.search}")',
          dataSource: {
            url: 'Companies/GetAllDynamic',
            selected: 'id,name',
            take: 50
          },
          option: {
            label: 'name'
          },
          // eslint-disable-next-line no-template-curly-in-string
          placeholder: '${root.L10n("all")}',
          styles: {
            minWidth: '20rem'
          }
        }
      },
      {
        id: 'employeeID',
        type: 'select',
        field: 'employeeID',
        // eslint-disable-next-line no-template-curly-in-string
        label: '${root.L10n("employee")}',
        permissions: {
          enable: 'isAllowToViewQuickRFQByParts'
        },
        options: {
          dataSource: 'Employees/GetAllDynamic?select=id,name as title&filter=isActive==true',
          // eslint-disable-next-line no-template-curly-in-string
          placeholder: '${root.L10n("all")}',
          defaultValue: employeeID,
          styles: {
            minWidth: '17rem'
          }
        }
      },
      {
        type: 'datemultiple',
        // eslint-disable-next-line no-template-curly-in-string
        label: '${root.L10n("po-date")}',
        field: 'poDate',
        options: {
          styles: {
            minWidth: '20rem'
          },
          tabs: [0, 2, 3, 4]
        }
      },
      {
        type: 'datemultiple',
        // eslint-disable-next-line no-template-curly-in-string
        label: '${root.L10n("quote-date")}',
        field: 'quoteDate',
        options: {
          styles: {
            minWidth: '20rem'
          },
          tabs: [0, 2, 3, 4]
        },
        place: 'inner'
      },
      {
        type: 'select',
        field: 'price',
        place: 'inner',
        // eslint-disable-next-line no-template-curly-in-string
        label: "${root.L10n('price')}",
        options: {
          defaultValue: null,
          valueTemplate: (data) => {
            switch (data.value) {
              case 'FULL':
                return `(${data.field} != null)`
              case 'EMPTY':
                return `(${data.field} == null)`
              default:
                return null
            }
          },
          dataSource: [
            {
              id: 'FULL',
              title: 'exist'
            },
            {
              id: 'EMPTY',
              title: 'not exist'
            }
          ]
        }
      }
    ]
  },
  permission: {
    edit: 'isAllowToEditRFQs'
  }
})
